module.exports = __webpack_public_path__ + "img/group-photo-icon.81713a93.png";